/*
 * @Author: edvardchen
 * @Date:   2016-11-22 10:05:12
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 17:27:51
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { visible, listenToScroll } from '../utility';

import shouldConstruct from './shouldConstruct';

/**
 * 监听模块露出
 * 被封装的 Component 必须拥有两个属性
 * 1. el 指向真实的 DOM node
 * 2. onExposure 执行上报的函数
 * @param  {React.Component} Component
 * @return {React.Component}
 */
export default function withExposureWatch(component) {
  const doConstruct = shouldConstruct(component);
  const Base = doConstruct ? component : React.Component;

  class ContainerWithExposure extends Base {
    static displayName = `${Base.displayName || Base.name}WithExposure`;

    static defaultProps = {
      once: true,
    };

    componentDidMount() {
      super.componentDidMount && super.componentDidMount();
      const callback = this.onExposure || this.props.onExposure;
      if (typeof callback !== 'function') {
        return;
      }
      const { once } = this.props;

      /* eslint-disable react/no-find-dom-node */
      // 不建议使用 findDOMNode，要每个组件都实现 el 有点麻烦
      // 这里是妥协的做法
      const el = this.el || ReactDOM.findDOMNode(this);
      if (visible(el)) {
        callback(this.props);
        if (once) {
          return;
        }
      }
      const watch = listenToScroll(() => {
        if (visible(el)) {
          callback(this.props);
          if (once) {
            watch.remove();
          }
        }
      });
      this.watchExposure = watch;
    }

    componentWillUnmount() {
      super.componentWillUnmount && super.componentWillUnmount();
      this.watchExposure && this.watchExposure.remove();
    }

    render() {
      const elementsTree = doConstruct ? super.render() : component(this.props);

      return elementsTree;
    }
  }

  return ContainerWithExposure;
}
